import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { toast } from "sonner";

import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({
  children,
  allowedRoles = [],
  requiredPermissions = [],
}) => {
  const { isAuthenticated, loading, roles, hasAnyPermission } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-sm text-muted-foreground">Loading...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (allowedRoles.length > 0) {
    const hasAllowedRole = roles.some((role) => allowedRoles.includes(role));

    if (!hasAllowedRole) {
      return <Navigate to="/" replace />;
    }
  }

  if (requiredPermissions.length > 0 && !hasAnyPermission(requiredPermissions)) {
    toast.error("You do not have permission to access this page.");
    return <Navigate to="/hotel/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
